// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-button-next[data-v-393412c4],.swiper-button-prev[data-v-393412c4]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.swiper-button-next[data-v-393412c4]:after,.swiper-button-prev[data-v-393412c4]:after{content:none!important}", ""]);
// Exports
module.exports = exports;
